import { FC } from 'react';

export type LabelValueGridRow = {
  id: string;
  rowStyle?: string;
  label: string;
  labelStyle?: string;
  value: string | number;
  noValueText?: string;
  valueStyle?: string;
  transform?: (value: any) => string;
};

const CustomGridLabelValueRow: FC<LabelValueGridRow> = ({
  id,
  rowStyle,
  label,
  labelStyle,
  value,
  noValueText,
  valueStyle,
  transform,
}) => {
  function displayValue(): string | number {
    if (!value) {
      return noValueText;
    }

    if (transform) {
      return transform(value);
    }

    return value;
  }

  function displayValueStyle(): string {
    if (!value) {
      return `${valueStyle ?? ''} text-gray-400 italic`;
    }

    return valueStyle ?? '';
  }

  return (
    <div id={id} className={rowStyle}>
      <div className={labelStyle}>{label}</div>
      <div className={displayValueStyle()}>{displayValue()}</div>
    </div>
  );
};

export default CustomGridLabelValueRow;
